import {CSSProperties, FC} from 'react';


export interface IIconSettingsNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSettingsNissan: FC<IIconSettingsNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m19.456 10.04-1.512-.504.712-1.424a.8.8 0 0 0-.152-.912L16.8 5.496a.8.8 0 0 0-.92-.152l-1.424.712-.504-1.512A.8.8 0 0 0 13.2 4h-2.4a.8.8 0 0 0-.76.544l-.504 1.512-1.424-.712a.8.8 0 0 0-.912.152L5.496 7.2a.8.8 0 0 0-.152.92l.712 1.424-1.512.504A.8.8 0 0 0 4 10.8v2.4a.8.8 0 0 0 .544.76l1.512.504-.712 1.424a.8.8 0 0 0 .152.912L7.2 18.504a.8.8 0 0 0 .92.152l1.424-.712.504 1.512a.8.8 0 0 0 .76.544h2.4a.8.8 0 0 0 .76-.544l.504-1.512 1.424.712a.8.8 0 0 0 .904-.152l1.704-1.704a.8.8 0 0 0 .152-.92l-.712-1.424 1.512-.504A.8.8 0 0 0 20 13.2v-2.4a.8.8 0 0 0-.544-.76ZM18.4 12.624l-.96.32a1.6 1.6 0 0 0-.928 2.256l.456.912-.88.88-.888-.48a1.6 1.6 0 0 0-2.232.928l-.32.96h-1.272l-.32-.96a1.6 1.6 0 0 0-2.256-.928l-.912.456-.88-.88.48-.888a1.6 1.6 0 0 0-.928-2.256l-.96-.32v-1.248l.96-.32A1.6 1.6 0 0 0 7.488 8.8l-.456-.888.88-.88.888.456a1.6 1.6 0 0 0 2.256-.928l.32-.96h1.248l.32.96a1.6 1.6 0 0 0 2.256.928l.912-.456.88.88-.48.888a1.6 1.6 0 0 0 .928 2.232l.96.32v1.272ZM12 8.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4Zm0 4.8a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2Z" clipRule="evenodd" />
        </svg>
    );
};
